<script lang="ts">
  import CircleHelp from "@lucide/svelte/icons/circle-help";
  import { openHelp } from "$lib/stores/ui";

  interface Props {
    sectionId: string;
  }
  let { sectionId }: Props = $props();
</script>

<button
  type="button"
  class="inline-flex items-center justify-center rounded-full w-5 h-5 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors shrink-0"
  onclick={() => openHelp(sectionId)}
  aria-label="Help"
  title="Help"
>
  <CircleHelp size={14} />
</button>
